import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.76, 0, 0.24, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);
